<template>
  <!-- TODO: two fieldsets: building information, and building owner information -->
  <div>
    <div class="form-fields">
      <fieldset>
        <legend>Building Information</legend>

        <div class="form-group">
          <label class="required">Building Type</label>
          <div class="form-check">
            <input class="form-check-input"
                   type="radio"
                   name="facility-type"
                   v-model="val.form.facility.type.$model"
                   value="Residential Single"
                   id="fac-type-res-single">
            <label class="form-check-label" for="fac-type-res-single">
              Residential (Single-Family Home)
            </label>
          </div>
          <div class="form-check">
            <input class="form-check-input"
                   type="radio"
                   name="facility-type"
                   v-model="val.form.facility.type.$model"
                   value="Residential 24"
                   id="fac-type-res">
            <label class="form-check-label" for="fac-type-res">
              Residential (2-4 units)
            </label>
          </div>
          <div class="form-check">
            <input class="form-check-input"
                   type="radio"
                   name="facility-type"
                   v-model="val.form.facility.type.$model"
                   value="Commercial"
                   id="fac-type-commercial">
            <label class="form-check-label" for="fac-type-commercial">
              Commercial (includes Industrial, Residential 5 or more units)
            </label>
          </div>
          <div class="form-check">
            <input class="form-check-input"
                   type="radio"
                   name="facility-type"
                   v-model="val.form.facility.type.$model"
                   value="School"
                   id="fac-type-school">
            <label class="form-check-label" for="fac-type-school">
              School
            </label>
          </div>
          <div class="form-check">
            <input class="form-check-input"
                   type="radio"
                   name="facility-type"
                   v-model="val.form.facility.type.$model"
                   value="Hospital"
                   v-bind:required="val.form.facility.type.$error"
                   id="fac-type-hospital">
            <label class="form-check-label" for="fac-type-hospital">
              Hospital
            </label>

            <div class="invalid-feedback">
              Building Type is required.
            </div>
            <span class="form-text">
              For commercial, school, and hospital facilities, one application must be completed per building.
            </span>
          </div>
        </div>
        <div v-if="form.projectType.toLowerCase() === 'demolition' && form.facility.type && form.facility.type.startsWith('Residential')">
          <strong>How many of each type of building are being demolished? (If 0, leave blank)</strong>
          <div class="row">
            <div class="col">
              <base-input v-model="form.facility.houseCount"
                          label="House"
                          :validation="val.form.facility.houseCount"
                          placeholder="(i.e., 1)"
                          v-numeric
                          min="0"
                          mask="####"
                          type="number"/>
            </div>
            <div class="col">
              <base-input v-model="form.facility.garageCount"
                          label="Garage"
                          :validation="val.form.facility.garageCount"
                          placeholder="(i.e., 1)"
                          v-numeric
                          min="0"
                          mask="####"
                          type="number"/>
            </div>
            <div class="col">
              <base-input v-model="form.facility.shedCount"
                          label="Shed"
                          :validation="val.form.facility.shedCount"
                          placeholder="(i.e., 1)"
                          v-numeric
                          min="0"
                          mask="####"
                          type="number"/>
            </div>
          </div>
        </div>

        <base-input v-model="form.facility.name"
                    label="Facility/Building Name"
                    placeholder="Facility/Building Name"
                    :validation="val.form.facility.name"
                    maxlength="50"/>

        <v-address v-model="form.facility.address"
                   :restrictState="true"
                   :chicagoLandCities="true"
                   labelPrefix="Facility Address"
                   :validation="val.form.facility.address"
                   :show-unincorporated="true"/>

        <div class="row">
          <div class="col">
            <base-input v-model="form.facility.contactName"
                        label="Building/Facility Contact Name"
                        placeholder="Full Name"
                        :validation="val.form.facility.contactName"/>
          </div>
          <div class="col">
            <base-input v-model="form.facility.contactPhone"
                        label="Building/Facility Contact Phone"
                        type="tel"
                        mask="(###)-###-####"
                        placeholder="(xxx)-xxx-xxxx"
                        :validation="val.form.facility.contactPhone"/>
          </div>
          <div class="col">
            <base-input v-model="form.facility.contactEmail"
                        label="Building/Facility Contact Email"
                        type="email"
                        placeholder="name@company.com"
                        :validation="val.form.facility.contactEmail"/>
          </div>
        </div>
        <base-input v-model="form.facility.priorUse"
                    label="Building/Facility Prior Use"
                    placeholder="Prior Use"
                    :validation="val.form.facility.priorUse"
                    maxlength="50"/>
        <base-input v-model="form.facility.presentUse"
                    label="Building/Facility Present Use"
                    placeholder="Present Use"
                    :validation="val.form.facility.presentUse"
                    maxlength="50"/>
        <base-input v-model="form.facility.futureUse"
                    label="Building/Facility Future Use"
                    placeholder="Future Use"
                    :validation="val.form.facility.futureUse"
                    maxlength="50"/>
        <div class="row">
          <div class="col-12 col-lg">
            <base-input v-model="form.facility.buildingSize"
                        label="Building Size (Sq Ft)"
                        placeholder="Sq Ft"
                        min="0"
                        :validation="val.form.facility.buildingSize"
                        type="number"/>
          </div>
          <div class="col-12 col-lg">
            <base-input v-model="form.facility.buildingFloors"
                        label="Building # of Floors"
                        placeholder="# of Floors"
                        min="0"
                        :validation="val.form.facility.buildingFloors"
                        type="number"/>
          </div>
          <!--<div class="col-12 col-lg" v-if="form.projectType.toLowerCase() === 'demolition'">-->
            <!--<base-input v-model="form.facility.constructionYear"-->
                        <!--label="Building Construction Year"-->
                        <!--placeholder="yyyy"-->
                        <!--message="Construction year must be a valid year."-->
                        <!--:validation="val.form.facility.constructionYear"-->
                        <!--mask="####"/>-->
          <!--</div>-->
        </div>

        <div class="row align-items-end" v-if="form.projectType.toLowerCase() === 'demolition'">
          <div class="col">
            <label>
              If there is asbestos present, asbestos must be removed/abated through the CCDES permitting process
            </label>
            <h5>
              NOTE: If asbestos is present you must apply for an asbestos abatement permit prior to completing this application.
            </h5>
          </div>
          <div class="w-100"></div>
          <div class="col">
            <yes-no v-model="form.asbestosPresent"
                    label="Is asbestos present?"
                    message="If asbestos is present it must be abated prior to demolition."
                    :validation="val.form.asbestosPresent"/>
          </div>
          <div class="w-100"></div>
          <div class="col">
            <base-textarea v-model="form.descriptionOfWorkPractices"
                           label="Description of procedures to be followed in the event that unexpected asbestos is found or
                     previously non-friable asbestos material becomes crumbled, pulverized or reduced to powder. "/>
          </div>
        </div>

        <div v-if="form.projectType.toLowerCase() === 'demolition'">
          <div class="row">
            <div class="col">
              <label>
                Attach supporting document showing year of building construction, such as construction permit, deed,
                appraisal date, etc.
              </label>
              <base-file-uploader
                v-model="form.files.buildingConstructionDate"
                label="Supporting Documentation"
                :file="form.existingFileDetails.buildingConstructionDate"
                :validation="val.form.files.buildingConstructionDate"/>
            </div>
          </div>
        </div>
      </fieldset>

      <fieldset>
        <legend>Building/Facility Owner Information</legend>
        <div class="row">
          <div class="col">
            <base-input v-model="form.facility.contact"
                        label="Owner Name"
                        placeholder="Owner Name"
                        :validation="val.form.facility.contact"/>
          </div>
        </div>
        <v-address v-model="form.facility.ownerAddress"
                   labelPrefix="Owner Address"
                   :validation="val.form.facility.ownerAddress"
                   :show-unincorporated="false"/>
        <div class="row">
          <div class="col">
            <base-input v-model="form.facility.phone"
                        label="Owner Phone"
                        type="tel"
                        mask="(###)-###-####"
                        placeholder="(xxx)-xxx-xxxx"
                        :validation="val.form.facility.phone"/>
          </div>
          <div class="col">
            <base-input v-model="form.facility.email"
                        label="Owner Email"
                        type="email"
                        placeholder="name@company.com"
                        :validation="val.form.facility.email"/>
          </div>
        </div>
      </fieldset>
    </div>
    <bottom-navigation link="project">Project Information</bottom-navigation>
  </div>
</template>

<script>
import ExplodedFieldset from '~/components/ExplodedFieldset';
import BaseInput from '~/components/BaseInput';
import YesNo from '~/components/YesNo';
import BaseFileUploader from '~/components/BaseFileUploader';
import VAddress from '~/components/VAddress';
import BottomNavigation from '~/components/BottomNavigation';
import BaseTextarea from '~/components/BaseTexarea';

export default {
  name: 'SiteInformation',
  components: {
    ExplodedFieldset, BaseInput, YesNo, BaseFileUploader, VAddress, BottomNavigation, BaseTextarea,
  },
  props: ['form', 'val', 'stateList'],
  mounted() {
    this.$emit('update:title', 'Project Site Information');
  },
};
</script>
